var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReschedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36483 2V3.37838H14.2215V2H15.0945V3.37838H18.15C18.391 3.37838 18.5865 3.58409 18.5865 3.83784V7.97297V18.5405C18.5865 18.7943 18.391 19 18.15 19H2.43649C2.19542 19 2 18.7943 2 18.5405V7.97297V3.83784C2 3.58409 2.19542 3.37838 2.43649 3.37838H5.49186V2H6.36483ZM14.2215 4.2973V5.67568H15.0945V4.2973H17.7135V7.51351H2.87297V4.2973H5.49186V5.67568H6.36483V4.2973H14.2215ZM2.87297 18.0811V8.43243H17.7135V18.0811H2.87297ZM6.92916 11.7833L9.11155 9.48597L9.72891 10.1357L8.29159 11.6486H11.3844C12.7103 11.6486 13.7851 12.78 13.7851 14.1757C13.7851 15.5713 12.7103 16.7027 11.3844 16.7027H7.23779V15.7838H11.3844C12.2281 15.7838 12.9121 15.0638 12.9121 14.1757C12.9121 13.2875 12.2281 12.5676 11.3844 12.5676H8.29157L9.72891 14.0806L9.11155 14.7303L6.92916 12.433C6.75869 12.2536 6.75869 11.9626 6.92916 11.7833Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReschedule);
export default __webpack_public_path__ + "static/media/reschedule.5a56b09c1b690cd5bbfd9f55525aeaac.svg";
export { ForwardRef as ReactComponent };